export function itemcardSubscriptions(wrapper = document) {
    let sections = wrapper.querySelectorAll(".itemcardOrderSections__section");
    let sectionTriggers = wrapper.querySelectorAll(".itemcardOrderSections__section .js-changeItemcardSection");

    if (sections) {
        if (sectionTriggers) {
            for (let trigger of sectionTriggers) {
                trigger.addEventListener("click", function () {
                    let currSection = trigger.closest(".itemcardOrderSections__section");
                    for (let section of sections) {
                        if (currSection === section) {
                            section.classList.add("is-active");
                            trigger.checked = true;
                        } else {
                            section.classList.remove("is-active");
                            let sectionTrigger = section.querySelector(".js-changeItemcardSection");
                            if (sectionTrigger) {
                                sectionTrigger.checked = false;
                            }
                        }
                    }
                });
            }
        }
    }

    let select = document.getElementById('itemcard_order_button_subsc_select');
    if (select) {
        let selectParentForm = select.closest('form');
        select.addEventListener("change", function () {
            let minQty = parseFloat(select.options[select.selectedIndex].getAttribute('data-minqty')),
                maxQty = parseFloat(select.options[select.selectedIndex].getAttribute('data-maxqty')),
                qtyStep = parseFloat(select.options[select.selectedIndex].getAttribute('data-qtystep')),
                savingsStr = select.options[select.selectedIndex].getAttribute('data-savings'),
                priceStr = select.options[select.selectedIndex].getAttribute('data-priceformatted'),
                price = parseFloat(select.options[select.selectedIndex].getAttribute('data-price')),
                qtyInput = document.getElementById('subscription_item_qty'),
                savingsDiv = document.querySelector('.itemcard_order_button_subscription_savings_wrapper .itemcard_order_button_subscription_savings_text'),
                priceDiv = selectParentForm.querySelector('.basePrice');

            if (qtyInput) {
                qtyInput.setAttribute('min', minQty);
                qtyInput.setAttribute('max', maxQty);
                qtyInput.setAttribute('step', qtyStep);
            }
            if (savingsDiv) {
                savingsDiv.innerText = savingsStr;
            }
            if (priceDiv) {
                priceDiv.querySelector('[itemprop="price"]').setAttribute('content', price);
                priceDiv.querySelector('[itemprop="lowprice"]').setAttribute('content', price);
                priceDiv.lastChild.textContent = priceStr;
            }
        });
    }
}